/* Local calendar dates for S2 (no time zones: it's the day on the visitor's calendar). */

/** Local calendar date → 'YYYY-MM-DD' (no time zones: it's the day on the visitor's calendar). */
export const toISO = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const fromISO = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y!, m! - 1, d!);
};

export function today(): Date {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}
